import React from "react";
import { Link } from "react-router-dom";
import { Star, Plus, Smartphone } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product }) {
  const { addToCart } = useCart();
  return (
    <div className="group bg-surface border border-white/10 rounded-2xl overflow-hidden hover:border-white/25 transition">
      <Link to={`/product/${product.slug}`}>
        <div className="aspect-square bg-gradient-to-br from-slate-700 to-slate-900 relative flex items-center justify-center overflow-hidden">
          {product.images?.[0] ? (
            <img src={product.images[0]} alt={product.name} className="w-full h-full object-cover" />
          ) : (
            <Smartphone size={44} className="text-white/70" strokeWidth={1.5} />
          )}
        </div>
      </Link>
      <div className="p-3">
        <div className="flex items-center gap-1 mb-1">
          <Star size={11} className="fill-yellow-400 text-yellow-400" />
          <span className="text-[11px] text-white/50 font-mono">{Number(product.rating).toFixed(1)}</span>
        </div>
        <Link to={`/product/${product.slug}`}>
          <h3 className="text-sm font-semibold leading-tight mb-1 hover:text-accent transition">{product.name}</h3>
        </Link>
        <p className="text-[11px] text-white/40 font-mono mb-3 truncate">{product.spec}</p>
        <div className="flex items-center justify-between">
          <span className="font-mono text-sm font-semibold text-mint">₹{product.price.toFixed(2)}</span>
          <button
            onClick={() => addToCart(product)}
            className="w-8 h-8 rounded-full bg-white/10 hover:bg-accent hover:text-black flex items-center justify-center transition"
          >
            <Plus size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
